import { render, staticRenderFns } from "./InputTallyCounter.vue?vue&type=template&id=7d1940c2&"
import script from "./InputTallyCounter.vue?vue&type=script&lang=js&"
export * from "./InputTallyCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports